module.exports = __webpack_public_path__ + "img/pedidos.1c27f950.jpeg";